import { createAuthenticatedClient } from "./authenticated-client"

export const apiClient = createAuthenticatedClient("/api", {
	contentType: "application/json",
})
